/*
 * /global 页面统一的 Sentry 初始化，与 timemark.com 上报到同一个 Sentry 项目
 * （sentry.timemark.com/37），国内页面仍各自上报到 sentry.xhey.top。
 *
 * DSN 是前端公开值（会打进 bundle），不属于密钥。
 */
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

const SENTRY_DSN =
  'https://a98ce74923fb35c43703464485cd149a@sentry.timemark.com/37'

// 与 timemark.com 对齐：生产与 staging 都上报，test/dev/local 不上报
const ENABLED_BUILD_ENVS = ['prod', 'staging']

// 与 timemark.com instrumentation-client.ts 保持一致的噪音过滤
const IGNORE_ERRORS = ['zaloJSV2', 'NativePageBackToWebview']

/**
 * @param {import('vue').App} app
 * @param {import('vue-router').Router} [router] 有路由的页面传入，用于按路由聚合性能数据
 */
export function initGlobalSentry(app, router) {
  const buildEnv = process.env.BUILD_ENV
  if (!ENABLED_BUILD_ENVS.includes(buildEnv)) return

  const tracingOptions = {
    // 只给同源请求注入 sentry-trace 头，避免跨域接口（app.timemark.com）因 CORS 预检失败
    tracingOrigins: ['localhost', /^\//]
  }
  if (router) {
    tracingOptions.routingInstrumentation =
      Sentry.vueRouterInstrumentation(router)
  }

  Sentry.init({
    app,
    dsn: SENTRY_DSN,
    environment: buildEnv === 'prod' ? 'production' : buildEnv,
    ignoreErrors: IGNORE_ERRORS,
    initialScope: { tags: { source: 'h5s-global' } },
    integrations: [new Integrations.BrowserTracing(tracingOptions)],
    tracesSampleRate: 0.5
  })
}
